<div class="flex flex-col gap-16 p-5">
  <!-- Sección de la cabecera. -->
  <section class="w-full flex flex-col items-center gap-5">
    <div class="text-2xl font-medium text-center">Editar una licencia</div>
  </section>

  <!-- Sección del cuerpo. -->
  <section>
    <!-- Formulario. -->
    <form class="flex flex-col" [formGroup]="form" (ngSubmit)="update()">
      <mat-form-field>
        <mat-label>ID</mat-label>
        <input type="number" name="id" formControlName="id" matInput readonly />
      </mat-form-field>

      @if (loadingProducts) {
      <div class="h-8 bg-gray-200 cursor-wait animate-pulse"></div>
      } @else { @if (products.length) {
      <mat-form-field class="w-full">
        <mat-label>Elige el producto</mat-label>
        <mat-select formControlName="productId">
          @for (product of products; track $index) {
          <mat-option [value]="product.id">{{ product.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      } @else {
      <div class="text-gray-500 text-center">No hay productos disponibles</div>
      } }

      <div class="flex gap-5 items-center">
        <mat-form-field class="grow">
          <mat-label>Alias</mat-label>
          <input
            type="text"
            name="alias"
            placeholder="Ex. GTW"
            maxlength="3"
            formControlName="alias"
            matInput
          />
        </mat-form-field>
        <mat-hint align="end">
          {{ formAlias?.value ? formAlias?.value.length : 0 }} / 3
        </mat-hint>
      </div>

      <div class="flex gap-5 items-center">
        <mat-form-field class="grow">
          <mat-label>Tipo</mat-label>
          <input
            type="text"
            name="type"
            placeholder="Ex. PT"
            maxlength="2"
            formControlName="type"
            matInput
          />
        </mat-form-field>
        <mat-hint align="end">
          {{ formType?.value ? formType?.value.length : 0 }} / 2
        </mat-hint>
      </div>

      <mat-form-field>
        <mat-label>Nombre</mat-label>
        <input type="text" name="name" formControlName="name" matInput />
      </mat-form-field>

      <mat-slide-toggle formControlName="status" class="mt-5">
        <span class="text-base pl-2">{{
          formStatus?.value ? "Activo" : "Deshabilitado"
        }}</span>
      </mat-slide-toggle>

      <!-- Errores. -->
      @if (errors) {
      <div class="flex flex-col gap-2 text-center mt-10">
        @for (error of errors; track error) {
        <span class="text-sm text-red-500">{{ error }}</span>
        }
      </div>
      }

      <!-- Botón de acción. -->
      <button
        type="submit"
        mat-flat-button
        class="mt-10"
        [disabled]="form.invalid || loadingUpdate"
      >
        @if (loadingUpdate) {
        <mat-spinner diameter="18"></mat-spinner>
        } @else {
        <span class="text-base">Editar</span>
        }
      </button>
    </form>
  </section>
</div>
